var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-layout"},[_c('div',{attrs:{"id":"scroller"}},[_c('div',{attrs:{"id":"scroll-el"}},[_c('div',{attrs:{"id":"max-w-full"}},[_c('main',[_c('nuxt')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }